import React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import parse from 'html-react-parser'
import { Textarea } from '~/lib/ui/textarea'
import { Input } from '~/lib/ui/input'

const FindingPurposePageThree = () => {
  const {
    formattedExerciseName,
    trackContent,
    handleChange,
    exerciseIndex,
    getResponse,
  } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageThreeTranslations = t('pages.2')
  console.log(trackContent)

  return (
    <div>
      <CallOutBox />
      <p>{pageThreeTranslations.purpose_statement}</p>
      <ul className="list-disc pl-5">
        <li className="mb-2">{parse(pageThreeTranslations.want_to_do)}</li>
        <li className="mb-2">{parse(pageThreeTranslations.who_to_help)}</li>
        <li className="mb-2">{parse(pageThreeTranslations.result)}</li>
      </ul>
      <p>{pageThreeTranslations.reflect}</p>
      <p className="!font-bold">
        {pageThreeTranslations.complete_purpose_statement}
      </p>
      <div className="mb-4 flex flex-wrap items-center gap-2">
        <span>{pageThreeTranslations.i_will}</span>
        <Input
          className="flex-grow rounded-[20px] px-2 md:max-w-96"
          onChange={(e) => handleChange(exerciseIndex, 'i_will', e)}
          value={getResponse(exerciseIndex, 'i_will') || ''}
        />
        <span>{pageThreeTranslations.to_help}</span>
        <Input
          className="flex-grow rounded-[20px] px-2 md:max-w-96"
          onChange={(e) => handleChange(exerciseIndex, 'to_help', e)}
          value={getResponse(exerciseIndex, 'to_help') || ''}
        />
        <span>{pageThreeTranslations.to_achieve}</span>
        <Input
          className="flex-grow rounded-[20px] px-2 md:max-w-96"
          onChange={(e) => handleChange(exerciseIndex, 'to_achieve', e)}
          value={getResponse(exerciseIndex, 'to_achieve') || ''}
        />
      </div>
      <p className="!font-bold">{pageThreeTranslations.review}</p>
      <p>{pageThreeTranslations.possible_ways}</p>
      <Textarea
        className="mb-2 min-h-[125px] w-full rounded-[20px]"
        onChange={(e) => handleChange(exerciseIndex, 'my_purpose', e)}
        value={getResponse(exerciseIndex, 'my_purpose') || ''}
      />
    </div>
  )
}

export default FindingPurposePageThree

const CallOutBox = () => {
  const { formattedExerciseName } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const callOutQuote = t('pages.2.callout_quote')
  const callOutQuoteAuthor = t('pages.2.callout_quote_author')

  return (
    <div className="mb-4 rounded-3xl bg-[#EAF4FF] px-4 pb-10 pt-4 first:mt-0 sm:px-24 sm:pt-4">
      <div className="h-max rounded-2xl bg-white px-4 py-6 sm:px-6 sm:pb-8 sm:pt-8">
        <div className="mb-4 flex font-bold">
          <span className="text-xl italic">{callOutQuote}</span>
        </div>
        <div>{parse(callOutQuoteAuthor)}</div>
      </div>
    </div>
  )
}
